const PAGINATION_ENABLED = true;

export const PAGINATION_CONFIG = {
  ENABLED: PAGINATION_ENABLED,
  LIMIT: PAGINATION_ENABLED ? 50 : 9999999999,
};
